var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-wrap items-center justify-between mb-3 lg:mb-0 md:flex-no-wrap"},[_c('h1',[_vm._v(_vm._s(_vm.$t("main.matching")))]),_c('pdf-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }